export default __webpack_public_path__ + "static/media/about-us-header.252f911e.avif";